import { useCallback, useEffect, useRef } from 'react';
import socketio, { SocketClientType } from '@/service/socketio';
import { getServerUrlFromConnection } from '@/utils';

interface Props {
  autoCloseOnUnmount?: boolean;
}

const useSocketIO = (props?: Props) => {
  const { autoCloseOnUnmount = true } = props || {};
  const socketInstance = useRef<SocketClientType>(null);
  const currentConnectInfo = useRef<GetConnectionInfoResponse>(null);

  useEffect(() => {
    return () => {
      if (autoCloseOnUnmount) {
        setTimeout(() => socketInstance.current?.destroy(), 200);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initSocket = useCallback((connectInfo: GetConnectionInfoResponse) => {
    currentConnectInfo.current = connectInfo;
    socketInstance.current = socketio.init(getServerUrlFromConnection(connectInfo));
  }, []);

  const reInitSocket = useCallback(() => {
    socketInstance.current = null;
    socketInstance.current = socketio.init(getServerUrlFromConnection(currentConnectInfo.current));
  }, []);

  const destroySocket = useCallback(() => {
    socketInstance.current?.destroy();
    socketInstance.current = null;
  }, []);

  return {
    socketInstance,
    initSocket,
    reInitSocket,
    destroySocket,
  };
};

export default useSocketIO;
